import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import HeaderCustom from "../../../components/HeaderCustom";
import { Backdrop, Box, CircularProgress, Container } from "@mui/material";
import SkeletonLoading from "../../../components/SkeletonLoading";
import '../../../styles/AppCss.css'
import { Padding, PaletaColor } from "../../../styles/StylesConstantes";
import { getCategorias, getFiltrarLocales } from "../../../api/ApiService";
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import { Delete, Edit, QrCode } from "@mui/icons-material";
import FitrosLocales from "./components/FitrosLocales";
import { useNavigate } from "react-router-dom";
import ModalQrComponents from "./components/ModalQrComponents";
import LocalesHeader from "./components/LocalesHeader";
import LocalesTableComponent from "./components/LocalesTableComponent";



function LocalesPage() {
    const [nameCedula, setNameCedula] = useState('');
    const [loading, setLoading] = useState(false);
    const [dataLocales, setDataLocales] = useState([]);
    const [loadingCargar, setLoadingCargar] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [localSelected, setLocalSelected] = useState(null);
    const [loadingDescargar, setLoadingDescargar] = useState(false);

    const [estadoSelected, setEstadoSelected] = useState({ label: 'Todos', value: "todos", id: 3 });
    const [estadoSearch, setEstadoSearch] = useState('');

    const [categorias, setCategorias] = useState([]);
    const [categoriaSearch, setCategoriaSearch] = useState('');
    const [categoriaSelected, setCategoriaSelected] = useState(null);

    const [metaPaginacion, setMetaPaginacion] = useState({
        current_page: 1,
        per_page: 10,
        total: 0,
        last_page: 1
    });
    const [perPage, setPerPage] = useState(10);




    const stateToken = useSelector(state => state.reducerGlobal.token);

    let history = useNavigate();




    useEffect(() => {
        if (stateToken) {
            handleListarCategorias();
        }
    }, [stateToken]);




    useEffect(() => {
        const timeOutId = setTimeout(() => {
            if (nameCedula.length > 2) {
                handleApiFiltrarLocalesTituloEstado(nameCedula);
            } else {
                handleApiFiltrarLocales(1);
            }
        }, 1500);
        return () => clearTimeout(timeOutId);
    }, [stateToken, nameCedula, estadoSelected, categoriaSelected, perPage]);



    //============================================================ funcion para filtrar por estado y nombre
    const handleApiFiltrarLocalesTituloEstado = (titulo) => {

        let body = {
            page: 1,
            per_page: perPage,
            estado: estadoSelected?.value,
            nombre: titulo,
            categoriaId: categoriaSelected?.id === undefined ? "" : categoriaSelected?.id
        };
        // console.log("handleApiFiltrarLocalesTituloEstado===>>", body);


        setLoadingCargar(true);

        getFiltrarLocales(stateToken?.access_token, body)
            .then(response => {
                // console.log("response==>getFiltrarLocales TITULO", response);

                setLoadingCargar(false);
                // setMetaPaginacion(response.meta);

                if (response.data.length > 0) {
                    setDataLocales(response.data);
                    setLoading(true);
                } else {
                    setDataLocales([]);
                    setLoading(true);
                }

                setMetaPaginacion({
                    current_page: response?.current_page,
                    per_page: response?.per_page,
                    total: response?.total,
                    last_page: response?.last_page
                });


            })
            .catch(error => {
                console.log("error==>getFiltrarLocales", error);
                setDataLocales([]);
                setLoading(true);
                setLoadingCargar(false);
            })
    };












    //============================================================ funcion para filtrar por estado y nombre
    const handleApiFiltrarLocales = (page = 1) => {
        let body = {
            page: page,
            per_page: perPage,
            estado: estadoSelected?.value,
            nombre: nameCedula,
            categoriaId: categoriaSelected?.id === undefined ? "" : categoriaSelected?.id
        };
        // console.log("handleApiFiltrarLocales====>>", body);
        // console.log("categoriaSelected", categoriaSelected);


        setLoadingCargar(true);

        getFiltrarLocales(stateToken?.access_token, body)
            .then(response => {
                // console.log("response==>getFiltrarLocales PAGE", response);

                setLoadingCargar(false);

                if (response.data.length > 0) {
                    setDataLocales(response.data);
                    setLoading(true);
                } else {
                    setDataLocales([]);
                    setLoading(true);
                }

                setMetaPaginacion({
                    current_page: response?.current_page,
                    per_page: response?.per_page,
                    total: response?.total,
                    last_page: response?.last_page
                });


            })
            .catch(error => {
                console.log("error==>getFiltrarLocales", error);
                setDataLocales([]);
                setLoading(true);
                setLoadingCargar(false);
            })
    };









    //=================================================================================================fapi de listar categorias
    const handleListarCategorias = () => {
        let body = {
            page: "",
            per_page: "",
            titulo: ""
        };

        getCategorias(stateToken?.access_token, body)
            .then((response) => {
                // console.log("response-getCategorias", response?.data);

                if (response?.data?.length > 0) {
                    setCategorias(response?.data);
                }

            })
            .catch((error) => {
                console.log("error-getCategorias", error);

            });
    };


    //=================================================================================================funcion para capturar el name y cedula
    const handleNameCedula = (e) => {
        setNameCedula(e);
    }




    //=========================================================funcion para seleccionar categoria
    const handleCategoriaSelected = (value) => {
        // console.log("value-handleCategoriaSelected: ", value);
        setCategoriaSelected(value);
    };

    //=========================================================funcion para buscar categoria
    const handleSearchCategoria = (value) => {
        // console.log("value-handleSearchCategoria: ", value);
        setCategoriaSearch(value);
    };

    //=========================================================funcion para buscar categoria
    const handleSearchEstado = (value) => {
        // console.log("value-handleSearchEstado: ", value);
        setEstadoSearch(value);
    };

    //=========================================================funcion para seleccionar categoria
    const handleEstadoSelected = (value) => {
        // console.log("value-handleEstadoSelected: ", value);
        setEstadoSelected(value);
    };








    //=============================================funcion para descargar el qr
    const handleQrClick = (item) => {
        console.log('Qr', item?.id);
        console.log('rows', item);
        // setLoadingDescargar(true);

        setOpenModal(true);
        setLocalSelected(item);
    }




    //=============================================funcion para descargar el qr
    const handleCloseModal = () => {
        setOpenModal(false);
        setLocalSelected(null);
    };



    //=============================================funcion para editar
    const handleEditClick = (item) => {
        console.log('Edit', item?.id);
        history(`/app/admin/local-editar/${item?.id}`);
    };


    //=============================================funcion para ver sin editar el local
    const handleVerLocal = (item) => {
        console.log('Edit', item?.id);
        history(`/app/admin/local-detalle/${item?.id}?mode=view`);
    };




    const handleAddLocal = () => {
        history('/app/admin/local-add');
    };

    const handlePerPageChange = (newPerPage) => {
        setPerPage(newPerPage);
    };





    return (
        <HeaderCustom>
            <div className="min-h-screen bg-gray-100 p-6">
                {loading ? (
                    <div>
                        <LocalesHeader
                            title="Locales"
                            subtitle="Administra y supervisa los locales de la plataforma."
                            handleAdd={handleAddLocal}
                        />




                        <div>
                            <FitrosLocales
                                nameCedula={nameCedula}
                                handleNameCedula={handleNameCedula}

                                estadoSelected={estadoSelected}
                                handleSearchEstado={handleSearchEstado}
                                handleEstadoSelected={handleEstadoSelected}

                                categorias={categorias}
                                handleCategoriaSelected={handleCategoriaSelected}
                                categoriaSelected={categoriaSelected}
                                handleSearchCategoria={handleSearchCategoria}


                                title={'Locales'}
                            />


                            <LocalesTableComponent
                                data={dataLocales}
                                metaPaginacion={metaPaginacion}
                                onPageChange={handleApiFiltrarLocales}
                                perPage={perPage}
                                onPerPageChange={handlePerPageChange}
                                handleEditarItem={handleEditClick}
                                handleVerLocal={handleVerLocal}
                                handleQrClick={handleQrClick}
                            // handleOpenModalDeleteEvento={handleOpenModalDeleteEvento}
                            />
                        </div>

                    </div>
                ) : (
                    <div className="bg-white rounded-xl shadow-md p-8">
                        <div className="h-6 bg-gray-200 rounded w-1/3 mb-6 animate-pulse" />
                        <div className="space-y-4">
                            <div className="h-10 bg-gray-200 rounded animate-pulse" />
                            <div className="h-10 bg-gray-200 rounded animate-pulse" />
                            <div className="h-24 bg-gray-200 rounded animate-pulse" />
                        </div>
                    </div>
                )}

                <ModalQrComponents
                    openModal={openModal}
                    loading={loadingDescargar}
                    handleCloseModal={handleCloseModal}
                    localSelected={localSelected}
                />


                <Backdrop open={loadingCargar} sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}>
                    <CircularProgress color="inherit" />
                </Backdrop>
            </div>
        </HeaderCustom>
    );
}

export default LocalesPage;